var map = {
	"./en_US1.png": "xQBT",
	"./mobile/en_US1.png": "qN+W",
	"./mobile/zh_CN1.png": "zeCk",
	"./mobile/zh_HANT1.png": "O7aO",
	"./zh_CN1.png": "DXVa",
	"./zh_HANT1.png": "qVzH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wOHm";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*1\.png$
// module id = wOHm
// module chunks = 1